'use client';

import classnames from 'classnames';

import { formatDayDateWithHour } from '../../../utils/date';
import type { BaseComponentProps } from '../../base-component.types';
import { Timeline } from '../../timeline';
import type { AuditLogType } from '../Question.types';

import styles from './AuditLogTimeline.module.scss';

export type AuditLogTimelineType = BaseComponentProps & {
  auditLog: AuditLogType[];
};

function AuditLogTimeline({
  style,
  className,
  auditLog,
  testId = 'ui-auditlog-timeline',
}: AuditLogTimelineType) {
  return (
    <Timeline
      style={style}
      className={classnames(styles['timeline'], className)}
      data-testid={testId}
      direction="vertical"
      slots={auditLog.map((log, index) => ({
        id: index.toString(),
        title: log.title,
        description: log.description,
        date: formatDayDateWithHour(log.date),
        icon: log.icon,
      }))}
    />
  );
}

export { AuditLogTimeline };
